<template>
  <el-menu default-active="1" :collapse="collapsed" collapse-transition router :default-active="$route.path"
    unique-opened class="el-menu-vertical-demo" background-color="#304156" text-color="#fff"
    active-text-color="#ffd04b">

    <div class="logobox">
      {{ collapsed ? "" : "EPC管理系统" }}
    </div>
    <el-menu-item index="1" :index="'/tree'">
      <i class="el-icon-folder-opened"></i>
      <span slot="title">产品名录管理</span>
    </el-menu-item>
    <el-menu-item index="8" :index="'/item'">
      <i class="el-icon-folder-opened"></i>
      <span slot="title">产品管理</span>
    </el-menu-item>
    <el-menu-item index="2" :index="'/itemName'">
      <i class="el-icon-s-flag"></i>
      <span slot="title">产品名称管理</span>
    </el-menu-item>
    <el-menu-item index="3" :index="'/video'">
      <i class="el-icon-service"></i>
      <span slot="title">视频管理</span>
    </el-menu-item>
    <el-menu-item index="4" :index="'/order'">
      <i class="el-icon-menu"></i>
      <span slot="title">订单管理</span>
    </el-menu-item>
    <el-menu-item index="4" :index="'/leaveword'">
      <i class="el-icon-chat-dot-round"></i>
      <span slot="title">留言管理</span>
    </el-menu-item>
    <el-menu-item index="5" :index="'/userInfo'">
      <i class="el-icon-user"></i>
      <span slot="title">用户管理</span>
    </el-menu-item>
    <el-menu-item index="6" :index="'/userLog'">
      <i class="el-icon-copy-document"></i>
      <span slot="title">用户日志管理</span>
    </el-menu-item>
    <el-menu-item index="7" :index="'/config'">
      <i class="el-icon-setting"></i>
      <span slot="title">网站配置</span>
    </el-menu-item>
  </el-menu>
</template>
<script>
export default {
  data() {
    return {
      collapsed: false,
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }

}
</script>
<style>
.el-menu-vertical-demo {
  width: 210px;
  min-height: 400px;
  border: none;
  text-align: left;
  margin-right: 0px;
}

.logobox {
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  padding-top: 10px;
  font-weight: bold;
  font-family: monospace;
}

.is-active {
  color: #ffd04b;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue